import React, { useEffect, useState } from "react";
import TextField from "../components/TextField";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { userLogin } from "../store/actions/user";
import { useNavigate } from "react-router-dom";
import { timeToUtc } from "../components/util";
const schema = yup.object({
  username: yup
    .string()
    .required("tidak boleh kosong!")
    .min(3, "min 3 karakter"),
  password: yup
    .string()
    .required("tidak boleh kosong!")
    .min(7, "min 7 karakter"),
});

function Login() {
  const dispatch = useDispatch();

  const { userStatus, user } = useSelector((state) => state.user);
  const [disableStatus, setDisableStatus] = useState(false);
  const methods = useForm({
    resolver: yupResolver(schema),
  });
  const navigate = useNavigate();
  const onLogin = (data) => {
    dispatch(userLogin(data));
  };
  useEffect(() => {
    if (userStatus === "success") {
      // dispatch(userAction.updateStatus)
      navigate("/");
    }
  }, [userStatus, dispatch, navigate]);
  useEffect(() => {
    if (userStatus === "loading") {
      setDisableStatus(true);
    } else {
      setDisableStatus(false);
    }
  }, [setDisableStatus, userStatus]);

  return (
    <div className="bg-gray-100 h-screen">
      {/* {timeToUtc('2022-01-01 00:00:00').toString()}-{timeToUtc('2022-01-01 23:59:59').toString()} */}
      {/* {userStatus}
      
      {JSON.stringify(user)} */}
      <div className="justify-center items-center flex w-full h-screen insert-0 w-auto mx-auto max-w-3xl">
        <div className="flex flex-col bg-white rounded-md bg-gray-400 p-5 w-full">
          <div className="text-white text-lg font-bold pt-3 pb-4 text-center">
            LOGIN
          </div>
          <form onSubmit={methods.handleSubmit(onLogin)}>
            <TextField
              label="Username"
              width="w-full"
              typeField="text"
              methods={methods}
              name_="username"
            />
            <TextField
              label="Password"
              width="w-full"
              typeField="password"
              name_="password"
              methods={methods}
            />
            <div className="w-full">
              <button
                className="text-white rounded bg-blue-500 px-3 py-2 w-full mt-2 mb-2 disabled:bg-blue-400"
                type="submit"
                disabled={disableStatus}
              >
                <div className="flex flex-row items-center justify-center inline">
                  {disableStatus ? <svg
                    className="inline mr-2 w-5 h-5 text-white-200 animate-spin dark:text-white fill-green-700"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>:<>LOGIN</>}
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
